import { render, staticRenderFns } from "./MantenedorInstitutions.vue?vue&type=template&id=6863c812&scoped=true&"
import script from "./MantenedorInstitutions.vue?vue&type=script&lang=js&"
export * from "./MantenedorInstitutions.vue?vue&type=script&lang=js&"
import style0 from "./MantenedorInstitutions.vue?vue&type=style&index=0&id=6863c812&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6863c812",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6863c812')) {
      api.createRecord('6863c812', component.options)
    } else {
      api.reload('6863c812', component.options)
    }
    module.hot.accept("./MantenedorInstitutions.vue?vue&type=template&id=6863c812&scoped=true&", function () {
      api.rerender('6863c812', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/tools/vistas/MantenedorInstitutions.vue"
export default component.exports